<main class="main">
    <div class="flex-container">
      <h2>{{ 'changesSources.title' | transloco }}</h2>
      <div class="filters">
        <div class="filter">
          <label for="userDateTime">{{ 'changesSources.dateRange' | transloco }}</label>
          <input id="userDateTime"
                 class="datetime-input"
                 mwlFlatpickr
                 [convertModelValue]="true"
                 [(ngModel)]="dateRange"
                 [enableTime]="false"
                 mode="range"
                 dateFormat="Y-m-d"
                 [altInput]="true"
                 altFormat="d.m.Y"
                 [locale]="{ rangeSeparator: ' - ' }"
                 [allowInput]="true"
                 (flatpickrReady)="onFlatpickrReady($event.selectedDates, $event.dateString, $event.instance)"
                 (flatpickrChange)="onDateRangeChange($event.selectedDates)"
                 [placeholder]="useDate ? ('changesSources.selectDateRange' | transloco) : ('changesSources.noDate' | transloco)">
        </div>
        <div class="filter">
          <label for="userDateTime">{{ 'changesSources.sourceType' | transloco }}</label>
          <fieldset>
            <label>
              <input type="radio"
                     name="source"
                     [checked]="!isShowBI"
                     (change)="toggleIsBI(false);" />
              {{ 'changesSources.dwh' | transloco }}
            </label>
            <label>
              <input type="radio"
                     name="source"
                     [checked]="isShowBI"
                     (change)="toggleIsBI(true);" />
              {{ 'changesSources.bi' | transloco }}
            </label>
          </fieldset>
        </div>
        <div class="filter">
          <label>{{ 'changesSources.dataSource' | transloco }}</label>
          <div class="form-group">
            <div class="dropdown" (click)="toggleOpen(); $event.stopPropagation()">
              <div class="dropdown-value">
                {{ selectedDataSource?.name || ('changesSources.selectDataSource' | transloco) }}
              </div>
              <div class="dropdown-list" *ngIf="open" (click)="$event.stopPropagation()">
                <div class="dropdown-item"
                     *ngFor="let dataSource of dataSources"
                     (click)="selectDataSource(dataSource.name); open = false; $event.stopPropagation()">
                  {{dataSource.name}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="filter">
          <label>{{ 'changesSources.acceptedFilter' | transloco }}</label>
          <fieldset>
            <label>
              <input type="radio"
                     name="acceptedFilter"
                     [value]="'all'"
                     [(ngModel)]="acceptedFilter"
                     (ngModelChange)="getLogData(true)" />
              {{ 'changesSources.all' | transloco }}
            </label>
            <label>
              <input type="radio"
                     name="acceptedFilter"
                     [value]="'accepted'"
                     [(ngModel)]="acceptedFilter"
                     (ngModelChange)="getLogData(true)" />
              {{ 'changesSources.accepted' | transloco }}
            </label>
            <label>
              <input type="radio"
                     name="acceptedFilter"
                     [value]="'not_accepted'"
                     [(ngModel)]="acceptedFilter"
                     (ngModelChange)="getLogData(true)" />
              {{ 'changesSources.notAccepted' | transloco }}
            </label>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="scroll-wrapper">
        <table>
          <thead>
            <tr>
              <th>{{ 'changesSources.number' | transloco }}</th>
              <th *ngIf="!isShowBI">
                <div class="th-filter">
                  <span>{{ 'changesSources.schema' | transloco }}</span>
                  <div class="th-dropdown-wrapper">
                    <div class="dropdown th-dropdown" (click)="toggleSchemasOpen(); $event.stopPropagation()">
                      <div class="dropdown-value">
                        {{ getSelectedSchemasLabel() }}
                      </div>
                      <div class="dropdown-list multi-select" *ngIf="openSchemas" (click)="$event.stopPropagation()">
                        <div class="dropdown-item"
                             *ngFor="let schema of uniqueSchemas"
                             (click)="toggleSchema(schema, $event)">
                          <input type="checkbox" [checked]="selectedSchemas.has(schema)">
                          <span>{{schema}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              <th>
                <div class="th-filter">
                  <span>{{ 'changesSources.entityType' | transloco }}</span>
                  <div class="th-dropdown-wrapper">
                    <div class="dropdown th-dropdown" (click)="toggleObjectTypesOpen(); $event.stopPropagation()">
                      <div class="dropdown-value">
                        {{ getSelectedObjectTypesLabel() }}
                      </div>
                      <div class="dropdown-list multi-select" *ngIf="openObjectTypes" (click)="$event.stopPropagation()">
                        <div class="dropdown-item"
                             *ngFor="let objectType of allObjectTypes"
                             (click)="toggleObjectType(objectType, $event)">
                          <input type="checkbox" [checked]="selectedObjectTypes.has(objectType)">
                          <span>{{ getObjectTypeLabel(objectType) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              <th>
                <div class="th-filter">
                  <div class="th-with-button">
                    <span>{{ 'changesSources.entity' | transloco }}</span>
                  </div>
                  <div class="th-dropdown-wrapper">
                    <div class="dropdown th-dropdown" (click)="toggleObjectNamesOpen(); $event.stopPropagation()">
                      <div class="dropdown-value">
                        {{ getSelectedObjectNamesLabel() }}
                      </div>
                      <div class="dropdown-list multi-select" *ngIf="openObjectNames" (click)="$event.stopPropagation()">
                        <div class="th-search-wrapper" style="padding: 0.5rem;">
                          <input type="text"
                                 class="th-search-input"
                                 [(ngModel)]="objectNameSearch"
                                 (ngModelChange)="onObjectNameSearchChange()"
                                 (click)="$event.stopPropagation()"
                                 [placeholder]="'changesSources.search' | transloco"
                                 style="width: 100%;"
                                 appBlurOnEnter>
                          <button *ngIf="objectNameSearch"
                                  class="clear-search-btn"
                                  (click)="clearObjectNameSearch(); $event.stopPropagation()"
                                  [title]="'changesSources.clearSearch' | transloco">
                            ✕
                          </button>
                        </div>
                        <div class="dropdown-item"
                             *ngFor="let objectName of uniqueObjectNames"
                             (click)="toggleObjectName(objectName, $event)"
                             [style.display]="objectNameSearch && !objectName.toLowerCase().includes(objectNameSearch.toLowerCase()) ? 'none' : 'flex'">
                          <input type="checkbox" [checked]="selectedObjectNames.has(objectName)">
                          <span>{{objectName}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              <th>
                <div class="th-filter">
                  <span [title]="'changesSources.actualityDesc' | transloco">{{ 'changesSources.actuality' | transloco }}</span>
                  <div class="th-dropdown-wrapper">
                    <div class="dropdown th-dropdown" (click)="toggleObjectActualityOpen(); $event.stopPropagation()">
                      <div class="dropdown-value">
                        {{ getSelectedObjectActualityLabel() }}
                      </div>
                      <div class="dropdown-list multi-select" *ngIf="openActuality" (click)="$event.stopPropagation()">
                        <div class="dropdown-item"
                             *ngFor="let actuality of allObjectActualities"
                             (click)="toggleActualityType(actuality, $event)">
                          <input type="checkbox" [checked]="selectedObjectActualities.has(actuality)">
                          <span>{{ getObjectActualityLabel(actuality) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              <th>
                <div class="th-filter">
                  <span>{{ 'changesSources.changeType' | transloco }}</span>
                  <div class="th-dropdown-wrapper">
                    <div class="dropdown th-dropdown" (click)="toggleChangeTypesOpen(); $event.stopPropagation()">
                      <div class="dropdown-value">
                        {{ getSelectedChangeTypesLabel() }}
                      </div>
                      <div class="dropdown-list multi-select" *ngIf="openChangeTypes" (click)="$event.stopPropagation()">
                        <div class="dropdown-item"
                             *ngFor="let changeType of changeTypes"
                             (click)="toggleChangeType(changeType, $event)">
                          <input type="checkbox" [checked]="changeType.selected">
                          <span>{{changeType.label}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              <th>
                <div class="th-filter">
                  <span>{{ 'changesSources.dateTime' | transloco }}</span>
                  <div class="th-dropdown-wrapper">
                    <div class="dropdown th-dropdown" (click)="toggleDateTimesOpen(); $event.stopPropagation()">
                      <div class="dropdown-value">
                        {{ getSelectedDateTimesLabel() }}
                      </div>
                      <div class="dropdown-list multi-select" *ngIf="openDateTimes" (click)="$event.stopPropagation()">
                        <div class="dropdown-item"
                             *ngFor="let dateTime of uniqueDateTimes"
                             (click)="toggleDateTime(dateTime, $event)">
                          <input type="checkbox" [checked]="selectedDateTimes.has(dateTime)">
                          <span>{{ formatDisplayDate(dateTime) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let change of paginatedChanges; let index = index">
              <td>
                <div class="cell-content">
                  {{ startIndex + index + 1 }}
                </div>
              </td>

              <td *ngIf="!isShowBI">
                <div class="cell-content">
                  {{ change.schemaName }}
                </div>
              </td>

              <td>
                <div class="cell-content">
                  {{ getObjectTypeLabel(change.objectType) }}
                </div>
              </td>

              <td class="clickable-cell" (click)="goToObject(change)">
                <div class="cell-content">
                  {{ change.objectName }}
                </div>
              </td>

              <td>
                <div class="cell-content">
                  {{ getObjectActualityLabel(change.is_actual ? 'yes' : 'no') }}
                </div>
              </td>

              <td>
                <div class="cell-content">
                  {{ change.type }}
                </div>
              </td>

              <td>
                <div class="cell-content">
                  {{ change.dateTime | date:'dd.MM.yyyy HH:mm:ss' }}
                </div>
              </td>

            </tr>
            <!-- Пустая строка-заглушка для заполнения минимальной высоты таблицы (для выпадающего списка в фильтрах) -->
            <tr class="spacer-row">
              <td [attr.colspan]="isShowBI ? 6 : 7"></td>
            </tr>
          </tbody>
        </table>

      </div>
      <div class="paginated-buttons">
        <button class="paginated-button" 
                (click)="prevPage()" 
                [disabled]="currentPage === 1">
          &lt;
        </button>
        <input class="paginated-input" 
               type="number" 
               [value]="currentPage" 
               (change)="onPageInput($event)"
               min="1" 
               [max]="totalPages"
               appBlurOnEnter />
        <span class="paginated-total">/ {{ totalPages }}</span>
        <button class="paginated-button" 
                (click)="nextPage()" 
                [disabled]="currentPage === totalPages">
          &gt;
        </button>
        <span class="paginated-info">
          {{ 'changesSources.showing' | transloco }}: {{ paginatedChanges.length }} {{ 'changesSources.of' | transloco }} {{ filteredChanges.length }}
        </span>
      </div>
    </div>
</main>
